module.exports = __webpack_public_path__ + "img/xfs-down-bg.e742dd37.png";